import { render, staticRenderFns } from "./StarredCameras.vue?vue&type=template&id=63532734&scoped=true"
import script from "./StarredCameras.vue?vue&type=script&lang=ts"
export * from "./StarredCameras.vue?vue&type=script&lang=ts"
import style0 from "./StarredCameras.vue?vue&type=style&index=0&id=63532734&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63532734",
  null
  
)

export default component.exports